import DataTable from 'datatables.net-react'
import 'datatables.net-dt/css/dataTables.dataTables.css';
import DT, {type Config} from 'datatables.net';
import React from "react";
import {getDatatableLanguagePack} from "./DatatableLanguagePack.tsx";

import {useTranslation} from "react-i18next";

interface WithUse {
    ['use']: (plugin: typeof DT) => void;
}

(DataTable as unknown as WithUse)['use'](DT);

type DataTableProps = {
    headers: string;
    headerKey?: string;
    items?: { name: string; }[]
    total?: number; // ← 총 할당량 (기본 4)
};
const DashboardTable = React.memo(
    ({headers, items = [], total = 4}: DataTableProps) => {
        const {t, i18n} = useTranslation("ui");

        const isI18nKeyLike = (s: string) => s.includes(".") && !/\s/.test(s);

        const headerTitle = headers
            ? (isI18nKeyLike(headers) ? t(headers) : headers)
            : "";

        const columns = [{title: headerTitle, data: "name"}];
        const options: Config = {
            destroy: true,
            paging: false,
            searching: false,
            order: [[0, "asc"]],
            ordering: true,
            lengthChange: false,
            language: getDatatableLanguagePack(i18n.resolvedLanguage),
            info: false,
        }
        return (
            <div style={{fontSize: "14px"}}>
                <DataTable
                    key={`dt-${i18n.resolvedLanguage}`}
                    data={items} columns={columns} className="display" options={options}>
                    <thead>
                    <tr>
                        <th className="bg-primary text-white"></th>
                    </tr>
                    </thead>
                    <tbody className="text-center"></tbody>
                    <tfoot>
                    <tr>
                        <td className="text-start text-secondary border-bottom">
                            <span>&ensp;{t("dashboard.dashboardTable.usageSummary", {total, used: items.length})}</span>
                        </td>
                    </tr>
                    </tfoot>
                </DataTable>
            </div>
        );
    });

export default DashboardTable;